import React, {useLayoutEffect, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import RightHeader from '../../generals-components/headers/right-header';
import SessionPageMain from './components/main';
import Footer from '../../generals-components/footer/footer';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function getUserNotifications() {  
    if (document.hidden) return;

    const response = await fetch('/api/get-account-notifications', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data;
    } else {
        return false;
    }
}

function SessionsPage() {
    const navigate = useNavigate();
    const [userNotifications, setUserNotifications] = useState(false)

    const getAndSetUserNotifications = async () => {
        setUserNotifications(await getUserNotifications())
    };

    useEffect(() => {
        const interval = setInterval(async () => {
            await getAndSetUserNotifications();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    useLayoutEffect(() => {
        const startDashboard = async () => {
            if (!await checkUserSession()) {
                navigate('/login');
                return
            }

            await getAndSetUserNotifications()
        };

        startDashboard();
        
    }, [navigate])

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="relative flex h-full min-h-screen w-full flex-col">
            <RightHeader userNotifications={userNotifications} currentPage={"Sessions"}/>

            <SessionPageMain/>

            <Footer currentPage={"Sessions"}/>
        </div>
    );
}

export default SessionsPage;